<div class="wrapperStyle">
  <div id="main-wrapper">
    <ngx-loading [show]="showSpinner" [config]="{ fullScreenBackdrop: true }"></ngx-loading>
    <app-header (found)="handleResults($event)"></app-header>
    <main>
      <div class=" tab inner-tab-container dashboardContainer topSpace">
        <div class="backTopqv">
          <a routerLink="/providerportal/pqv-dashboard" class="patient-quick-view"><img
          src="assets/images/icons/left-arrow.svg" alt=""> View Clinical Documentation</a>
        </div>

        <h1 class="carelon-page-title m-t-20">Patient Dashboard</h1>
        @if (memberDetails != null ) {
          <div class="patient-dashboard-section">
            <div class="row memberDetailsContainer">
              <div class="col-md-5 col-sm-12 marginTop">
                <div class="row">
                  <div class="col-md-7 memberDetails-section">
                    <div>
                      <img src="assets/images/icons/memberDetailIcon.svg" alt="memberDetailIcon">
                    </div>
                    <div class="member-details">
                      <h4 class="fw-bold">{{memberDetails.memberFirstName}}
                      {{memberDetails.memberLastName}}</h4>
                      <p><span class="fw-bold">Member ID </span>: {{memberDetails.memberHmoID}}</p>
                    </div>
                  </div>
                  <div class="col-md-5 mem-details">
                    <h5 class="fw-bold">Member Details</h5>
                    <p> <span class="fw-bold">DOB </span> : {{memberDetails.memberDOB}}</p>
                    <p> <span class="fw-bold">Age </span> : {{memberAge}}</p>
                  </div>
                </div>
              </div>
              <div class="col-md-7 col-sm-12 healthPlanDetails">
                <div class="row">
                  <div class="col-md-3 pcp-details">
                    <h5 class="fw-bold">PCP Details</h5>
                    <p>{{memberDetails.pcpName}}</p>
                  </div>
                  <div class="col-md-4">
                    <h5 class="fw-bold">Health Plan Information</h5>
                    <!-- <p> <span>CMS Plan ID </span> : - </p> -->
                    <div><p>{{memberDetails.clientname}}</p></div>
                    <div>
                      <p><span>Effective </span> : {{memberDetails.Memberproducteffectivedate | date:'MM/dd/yyyy'}} </p>
                    </div>
                    <div>
                      <p><span>Term </span> : {{memberDetails.MemberproductTermdate | date:'MM/dd/yyyy'}}</p>
                    </div>
                  </div>
                  <div class="col-md-5">
                    <h5 class="fw-bold">Member Product Name</h5>
                    <p>{{memberDetails.Plandescription}}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="medication-labdetails-section">
              <ul class="nav nav-tabs" id="myTab" role="tablist">
                <li class="nav-item" role="presentation"> <button class="nav-link active"
                  id="MedicationDetails-tab" data-bs-toggle="tab" data-bs-target="#MedicationDetails"
                type="button" role="tab">Medication details</button> </li>
                <li class="nav-item" role="presentation"> <button class="nav-link" id="LabDetails-tab"
                  data-bs-toggle="tab" data-bs-target="#LabDetails" type="button" role="tab">Lab
                details</button>
              </li>
              <li class="nav-item" role="presentation"> <button class="nav-link" id="clinicalDetails-tab"
                data-bs-toggle="tab" data-bs-target="#clinicalDetails" type="button" role="tab">Clinical Visits
              </button>
            </li>
            </ul>
            <div class="tab-content mt-3" id="myTabContent">
              <div class="tab-pane fade show active" id="MedicationDetails" role="tabpanel">
                @if (memberMedicationDetails.length!=0 ) {
                  <app-medicationDetails
                  [medicationData]="memberMedicationDetails"></app-medicationDetails>
                } @else {
                  <p>No records available currently!</p>
                }
              </div>
              <div class="tab-pane fade show " id="clinicalDetails" role="tabpanel">
                <app-clinical-visit [filesData]="fileData" (dateRangeSelected)="handleDateChange($event)" (dateRangeSelected1)="receiveRange($event)"></app-clinical-visit>

                <!-- @if (fileData.length != 0 ) {                
                  <app-clinical-visit [filesData]="fileData" (dateRangeSelected)="handleDateChange($event)" (dateRangeSelected)="receiveRange($event)"></app-clinical-visit>
                } @else {
                  <p>No records available currently!</p>
                } -->
              </div>

              <div class="tab-pane fade" id="LabDetails" role="tabpanel">
                @if (memberLabDetails() != null ) {
                  <app-labDetails
                  [labDetailsData]="memberLabDetails"></app-labDetails>
                } @else {
                  <p>No records available currently!</p>
                }
              </div>
            </div>
          </div>
        </div>
      } @else {
        <p>No records available currently!</p>
      }
    </div>
  </main>
</div>


<app-footer></app-footer>
</div>
<!-- Dialog box -->
<div class="modal dataNotAvailableModal" id="dataNotAvailableModal" data-bs-backdrop="static" data-bs-keyboard="false"
  role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Let’s Try Again</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal"
        routerLink="/providerportal/pqv-dashboard"></button>
      </div>
      <div class="modal-body">
        <p>Please select your <b>PCP</b> and <b>Site</b> again to view
      the member dashboard</p>
    </div>
    <div class="modal-footer d-flex justify-content-center">
      <div>
        <button type="button" class="btn carelon-btn buttonInfo" routerLink="/providerportal/pqv-dashboard"
        data-bs-dismiss="modal">SELECT DETAILS</button>
      </div>
    </div>
  </div>
</div>
</div>